import React from "react";
import logo from "./logo.png";
import avivLogo from "./avivLogo.png";
import sim from "./sim.jpeg";
import aviad from "./cgn.png";
import arrivo from "./arrivo.png";
import tiptop from "./TipTop2.png";
import tomer from "./tomer.png";
import liorwd from "./p3.png";
import dubi from "./dubi.png";
import elal from "./elal.jpeg";
import cls from "./cls.jpeg";
import igal from "./igal.png";
import logogo from "./logogo.png";
import panda from "./panda.jpeg";
import miba from "./miba.png";
import rn from "./rn1.jpeg";
import { FlexRowBetween } from "../Style";

const dic = {
  CallUp: {
    link: "https://callup.ltd",
    pic: logo,
    size: "60px",
    title: "CALLUP rsvp",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  TomerIsakov: {
    link: `https://wa.me/972506654051/?text=היי, `,
    pic: tomer,
    size: "80px",
    title: "TOMER ISAKOV",
    subTitle: "EVENT PRODUCTIONS",
  },
  Panda: {
    link: `https://wa.me/972527506023/?text=היי, `,
    pic: panda,
    size: "60px",
    title: "Panda",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  Miba: {
    link: `https://wa.me/972508768450/?text=היי, `,
    pic: miba,
    size: "60px",
    title: "Miba",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  BeSimple: {
    link: "https://b-s.fun",
    pic: logogo,
    size: "40px",
    title: "Be Simple",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  LetMeSit: {
    link: `https://wa.me/972537772168/?text=היי, `,
    pic: avivLogo,
    size: "60px",
    title: "LetMeSit",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  Let_Me_Sit: {
    link: `https://wa.me/972527734788/?text=היי, `,
    pic: avivLogo,
    size: "60px",
    title: "LetMeSit",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "שמחת עולם": {
    link: `https://wa.me/972504077789/?text=היי, `,
    pic: sim,
    size: "80px",
    title: "שמחת עולם",
    subTitle: "ניהול אירוע מקצה לקצה",
  },
  TipTop: {
    link: `https://wa.me/972552593397/?text=היי, `,
    pic: tiptop,
    size: "80px",
    title: "TipTop",
    subTitle: "ניהול אירועים, אישורי הגעה הושבה",
  },
  Arrivo: {
    link: `https://wa.me/972585958777/?text=היי, `,
    pic: arrivo,
    size: "80px",
    title: "Arrivo",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "משחק הכיסאות": {
    link: `https://wa.me/972503064555/?text=היי, `,
    pic: aviad,
    size: "140px",
    title: "משחק הכיסאות",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "מארגנת החתונות": {
    link: `https://wa.me/972523665635/?text=היי, `,
    pic: liorwd,
    size: "80px",
    title: "מארגנת החתונות",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "דובי הפקות": {
    link: `https://wa.me/972549922140/?text=היי, `,
    pic: dubi,
    size: "80px",
    title: "דובי הפקות",
    subTitle: "ניהול והפקת אירועים",
  },
  "אל על": {
    link: `https://wa.me/972558828327/?text=היי, `,
    pic: elal,
    size: "80px",
    title: "אל על",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  קליקסיט: {
    link: `https://wa.me/972502692682/?text=היי, `,
    pic: cls,
    size: "80px",
    title: "קליקסיט",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
  "PM ניהול והפקות אירועים": {
    link: `https://wa.me/972505533440/?text=היי, `,
    pic: igal,
    size: "80px",
    title: "P & M",
    subTitle: "ניהול והפקות אירועים",
  },
  RN_EVENTS: {
    link: `https://wa.me/972585958777/?text=היי, `,
    pic: rn,
    size: "80px",
    title: "RN_EVENTS",
    subTitle: "אישורי הגעה וסידורי הושבה",
  },
};
const Footer = ({ producer = "CallUp" }) => {
  return (
    <a
      target={"_blank"}
      rel="noopener noreferrer"
      href={
        dic[producer] !== undefined ? dic[producer].link : dic["CallUp"].link
      }
      style={{
        width: "100%",
        marginTop: "30px",
        padding: "16px 20px",
        color: "#3A3C3F",
        textDecoration: "none",
        background: "rgba(255,255,255,0.75)",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        borderRadius: "16px",
        boxSizing: "border-box",
      }}
    >
      <FlexRowBetween
        style={{
          justifyContent: "space-around",
          padding: "0px 0",
        }}
      >
        <div>
          <FlexRowBetween
            style={{
              fontFamily: "ralewayLight",
              justifyContent: "center",
              fontStyle: "italic",
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            {dic[producer] !== undefined
              ? dic[producer].title
              : dic["CallUp"].title}
          </FlexRowBetween>
          <FlexRowBetween
            style={{
              fontWeight: "100",
              justifyContent: "center",
              fontSize: "12px",
              fontStyle: "oblique",
            }}
          >
            {dic[producer] !== undefined
              ? dic[producer].subTitle
              : dic["CallUp"].subTitle}
          </FlexRowBetween>
        </div>
        <img
          src={
            dic[producer] !== undefined ? dic[producer].pic : dic["CallUp"].pic
          }
          //   src={dic[producer.substring(1)].pic}
          alt="logo"
          style={{
            width:
              dic[producer] !== undefined
                ? dic[producer].size
                : dic["CallUp"].size,
          }}
        />
      </FlexRowBetween>
    </a>
  );
};

export default Footer;
